/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
import moment from 'moment';
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  useLocation,
  useMatch,
  useNavigate,
  useParams,
} from 'react-router-dom';

import MuiAlert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import Grid2 from '@mui/material/Grid2';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import LinearProgress from '@mui/material/LinearProgress';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useDropzone } from 'react-dropzone';
import {
  MdAdd,
  MdRemove,
  MdClose,
  MdContentCopy,
  MdDelete,
  MdDownload,
  MdExpandLess,
  MdExpandMore,
  MdFolder,
} from 'react-icons/md';

import api, { authHeader } from '../../../../../services/API/apiConfig';

import { DialogBox } from '../../../singleComponents/dialogs/DialogBox';
import { Dropzone } from '../../../singleComponents/dropzone/Dropzone';
import { FormBaseScreen } from '../../../singleComponents/forms/FormBaseScreen/FormBaseScreen';
import ToasterBox from '../../../singleComponents/toaster/ToasterBox';

import GlobalContext from '../../../../../context/GlobalContext';

import { currencyMask, currencyMaskString } from '../../../../styles/util';
import {
  AccordionDisableStyled,
  AccordionStyled,
  AttachmentsListStyled,
  Box1Styled,
  Box2Styled,
  BoxesStyled,
  BtnSubmitStyled,
  DeleteDivStyled,
  DropzoneStyled,
  FileNameStyled,
  IconStyled,
  LinksAndTotalStyled,
  LoadingDivStyled,
  PlusBTNStyled,
  RemoveBTNStyled,
  SwitchContainerStyled,
  SwitchStyled,
  TitleAndDeleteContainerStyled,
} from './EditPayable.styles';

const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

export function EditPayable() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    companyData: { subdomain },
  } = useContext(GlobalContext);

  const user = JSON.parse(window.localStorage.getItem('user'));
  const isAdmin = user?.user_type === 'admin';

  const baseURL = process.env.REACT_APP_API;
  const protocol =
    process.env.REACT_APP_NODE_ENV === 'development' ? 'http' : 'https';

  const duplicateMatch = useMatch('/new-release/duplicate/:id');
  const { id: routeId, ...route } = useParams();
  const payableId = routeId;

  const { getRootProps, getInputProps, acceptedFiles, isDragActive } =
    useDropzone({ accept: 'application/pdf' });

  const [barcode, setBarcode] = useState({});
  const [bankSlipFile, setBankSlipFile] = useState([]);
  const [bankSlipTotal, setBankSlipTotal] = useState(0);
  const [constructionName, setConstructionName] = useState('');
  const [suppliers, setSuppliers] = useState([]);
  const [supplierId, setSupplierId] = useState('');
  const [bankSlipNumber, setBankSlipNumber] = useState('');
  const [description, setDescription] = useState('');
  const [due, setDue] = useState('');
  const [status, setStatus] = useState(0);
  const [constructionId, setConstructionId] = useState(null);
  const [total, setTotal] = useState(0);
  const [totalDefault, setTotalDefault] = useState();
  const [checked, setChecked] = useState(false);
  const [files, setFiles] = useState([]);
  const [deleteFileIds, setDeleteFileIds] = useState([]);
  const [unduplicateFiles, setUnduplicateFiles] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [loadingAttachment, setLoadingAttachment] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [successSubmit, setSuccessSubmit] = useState(false);
  const [openDialogAttachment, setOpenDialogAttachment] = useState(false);
  const [attachmentId, setAttachmentId] = useState(null);
  const [category, setCategory] = useState(null);
  const [categoryId, setCategoryId] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [ocrLoading, setOcrLoading] = useState(false);

  const [registeredCategories, setRegisteredCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [addictionalInfo, setAddictionalInfo] = useState(false);
  const [budgetsItems, setBudgetsItems] = useState([]);

  const [openSnackBar, setOpenSnackBar] = useState(false);

  const filteredItems = useMemo(() => {
    let destroyCount = 0;
    const newItems = items.map((item) => {
      const newItem = { ...item, destroyBeforeCount: destroyCount };
      if (item._destroy) destroyCount += 1;
      return newItem;
    });

    return newItems.filter((item) => !item._destroy);
  }, [items]);

  const goBack = () => navigate(-1);

  const handleAddItems = () => {
    const newItems = [...items, { category_id: '', item_id: '', total: '' }];
    setItems(newItems);
  };

  const handleRemoveItems = (selectedItem) => {
    let newItems;

    if (!selectedItem.id) {
      newItems = [...items];
      const removeIndex = newItems.findIndex((item) => item.id === '');
      newItems.splice(removeIndex, 1);
    } else {
      newItems = items.map((item) =>
        item.id === selectedItem.id ? { ...item, _destroy: true } : item
      );
    }

    const newTotal = newItems.reduce((acc, curr) => {
      const value = Number(curr.total.replace('.', '').replace(',', '.'));
      return curr._destroy ? acc + 0 : acc + value;
    }, 0);

    if (newItems.every((item) => item._destroy)) {
      setAddictionalInfo(false);
    }

    setItems(newItems);
    setTotal(newTotal);
  };

  const handleCloseSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };

  function handleChangeItems(event, index, prop) {
    const newItem = { ...items[index], [prop]: event.target.value };
    const newItems = [...items];
    newItems[index] = newItem;

    setItems(newItems);
  }

  function handleChangeCategory(event) {
    const { value } = event.target;
    setCategoryId(value);
    setCategory({ id: value });
  }

  function handleChangeTotalInputDefault(event) {
    let { value } = event.target;
    if (value === '') {
      setTotal(0);
      setTotalDefault('');
      return;
    }
    setTotalDefault(value);
    value = Number(value.replace('.', '').replace(',', '.'));
    setTotal(value);
  }

  function handleChangeAmount(event, index) {
    const newItem = { ...items[index], total: event.target.value };
    const newItems = [...items];
    newItems[index] = newItem;

    const newTotal = newItems.reduce((acc, curr) => {
      const value = Number(curr.total.replace('.', '').replace(',', '.'));
      return curr._destroy ? acc + 0 : acc + value;
    }, 0);

    setItems(newItems);
    setTotal(newTotal);
  }

  const handleChangeStatus = useCallback(
    (event) => {
      setChecked(event.target.checked);
      setStatus(checked ? 0 : 1);
    },
    [checked]
  );

  function handleOpenDialogDeletePayable() {
    setOpenDialog(true);
  }

  const handleCloseDialogDeletePayable = useCallback(() => {
    setOpenDialog(false);
  }, [setOpenDialog]);

  const handleDeletePayable = useCallback(async () => {
    if (!duplicateMatch && payableId) {
      await api
        .delete(`/payables/${payableId}`, { headers: authHeader() })
        .then((res) => {
          setOpenDialog(false);
          setSuccessMessage('Lançamento removido com sucesso.');
          setSuccessSubmit(true);

          setTimeout(() => {
            goBack();
          }, 2000);
          if (res.data.status === 2) {
            setErrorMessage('Não foi possível remover o fornecedor');
            setErrorSubmit(true);
          }
        });
    }
  }, [duplicateMatch, payableId]);

  async function getFiles() {
    setLoadingAttachment(true);
    await api
      .get(`/payables/${payableId}/attachments`, { headers: authHeader() })
      .then((res) => {
        const { data } = res.data;

        if (duplicateMatch) {
          setFiles(data.filter(({ id }) => !deleteFileIds.includes(id)));
        } else {
          setFiles(data);
        }

        if (!unduplicateFiles) {
          setUnduplicateFiles(data);
        }
        setLoading(false);
        setLoadingAttachment(false);
      });
  }

  function submitAttachments(attachedFiles) {
    api
      .post(`/payables/${payableId}/attachments`, attachedFiles, {
        headers: authHeader(),
      })
      .then(() => {
        getFiles();
      });
  }

  async function deleteAttachment(fileId) {
    setLoadingAttachment(true);
    if (duplicateMatch) {
      setDeleteFileIds((prev) => [...prev, fileId]);
      setFiles((prevFiles) => prevFiles.filter((f) => f.id !== fileId));
      setOpenDialogAttachment(!openDialogAttachment);
      setLoadingAttachment(false);
    } else {
      await api
        .delete(`/payables/${payableId}/attachments/${fileId}`, {
          headers: authHeader(),
        })
        .then(() => {
          setOpenDialogAttachment(!openDialogAttachment);
          setTimeout(() => {
            getFiles();
          }, 2000);
        });
    }
  }

  async function downloadAttachment(fileId) {
    api
      .get(`/payables/${payableId}/attachments/${fileId}`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        window.open(`${protocol}://${subdomain}.${baseURL}${data.path.url}`);
      });
  }

  function sendFile(file) {
    setOcrLoading(true);
    api
      .post('/payables/ocr', file, { headers: authHeader() })
      .then((res) => {
        const { data } = res.data;

        let date = moment(data.expiration_date, 'DD/MM/YYYY');
        date = date.format('YYYY-MM-DD');
        setBankSlipNumber(data.barcode);
        setDue(date);
        setBankSlipTotal(data.value);
        setSupplierId(data.supplier.id);
        setTotalDefault(currencyMaskString(data.value));
        setTotal(data.value);
        setOcrLoading(false);
      })
      .catch(() => {
        setOcrLoading(false);
      });
  }

  const handleSubmitEdit = async () => {
    const totalAmount = total > 0 ? total : bankSlipTotal;

    let value = 0;
    let id;

    let newItemArray = items.map((item) => {
      value = Number(item.total.replace('.', '').replace(',', '.'));
      return { ...item, total: value };
    });

    if (route['*'].includes('duplicate')) {
      newItemArray = newItemArray.filter((item) => !item._destroy);
    }

    let data = {
      payable: {
        description,
        due,
        bank_slip_number: bankSlipNumber,
        supplier_id: supplierId,
        status,
        payable_items_attributes: newItemArray,
        total: totalAmount,
        category_id: categoryId,
      },
    };

    if (
      duplicateMatch &&
      (total === bankSlipTotal || total === 0 || bankSlipTotal === 0)
    ) {
      data = {
        ...data,
        payable: { ...data.payable, construction_id: constructionId },
      };

      await api
        .post('/payables', data, { headers: authHeader() })
        .then((res) => {
          id = res.data.data.id;
        });

      const duplicateQuery = files
        .map((f) => `copies[]=${f?.id?.toString()}`)
        .join('&');

      await api
        .post(`/payables/${id}/attachments?${duplicateQuery}`, null, {
          headers: authHeader(),
        })
        .then(() => {
          setSuccessMessage('Lançamento cadastrado com sucesso');
          setSuccessSubmit(true);
          setTimeout(() => {
            if (location.state && location.state.from) {
              navigate(location.state.from);
            } else {
              navigate('/');
            }
          }, 2000);
        });

      const originalIds = unduplicateFiles.map((file) => file.id);
      const filesToDelete = files.filter(
        (file) => !originalIds.some((original) => original === file.id)
      );

      Promise.all(
        filesToDelete.map((file) =>
          api.delete(`/payables/${payableId}/attachments/${file.id}`, {
            headers: authHeader(),
          })
        )
      );
    } else if (total === bankSlipTotal || total === 0 || bankSlipTotal === 0) {
      api
        .patch(`/payables/${payableId}`, data, { headers: authHeader() })
        .then(() => {
          setSuccessMessage('Lançamento editado com sucesso');
          setSuccessSubmit(true);
          submitAttachments(bankSlipFile);
          setTimeout(() => {
            if (location.state && location.state.from) {
              navigate(location.state.from);
            } else {
              navigate('/');
            }
          }, 2000);
        });
    } else {
      setErrorMessage('A soma dos itens e o total do boleto não coincidem');
      setErrorSubmit(true);
      setTimeout(() => {
        setErrorSubmit(false);
      }, 2000);
    }
  };

  useEffect(() => {
    setBarcode(acceptedFiles);
    setBankSlipFile(acceptedFiles);
  }, [acceptedFiles]);

  useEffect(() => {
    const fd = new FormData();
    const bankSlipFD = new FormData();
    if (barcode.length) {
      fd.append('file', barcode[0]);
      sendFile(fd);
    }
    if (bankSlipFile && bankSlipFile.length) {
      bankSlipFD.append('files[]', bankSlipFile[0]);
      setBankSlipFile(bankSlipFD);
    }
  }, [barcode]);

  useEffect(() => {
    api
      .get(`/payables/${payableId}`, { headers: authHeader() })
      .then((response) => {
        const { data } = response.data;
        if (data) {
          setStatus(data.status_id);
          setConstructionId(data.construction.id);
          setConstructionName(data.construction.name);
          setBankSlipNumber(data.bank_slip_number);
          setDescription(data.description);
          setDue(moment(data.due, 'DD/MM/YYYY').format('YYYY-MM-DD'));
          setSupplierId(data.supplier.id);
          const totalTemp = parseFloat(data.total);
          setTotal(totalTemp);
          setTotalDefault(currencyMaskString(totalTemp));
          if (data.category !== undefined) setCategory(data.category);

          const payableItems = [];
          let totalAux = 0;

          data.payable_items.forEach((payableItem) => {
            payableItems.push({
              id: payableItem.id,
              category_id: payableItem.category.id,
              item_id: payableItem.item_id,
              total: currencyMaskString(payableItem.total),
            });

            totalAux += payableItem.total;
          });
          if (payableItems.length) {
            setAddictionalInfo(true);
            setItems(payableItems);
            setTotal(totalAux);
          }
        }
      });

    api
      .get('/suppliers', { headers: authHeader() })
      .then((response) => setSuppliers(response.data.data));

    getFiles();
  }, []);

  useEffect(() => {
    setChecked(status !== 0);
  }, [status]);

  useEffect(() => {
    setLoadingAttachment(true);
    setTimeout(() => {
      getFiles();
    }, 2500);
  }, [attachments]);

  useEffect(() => {
    if (constructionId) {
      api
        .get(`/constructions/${constructionId}/budgets?array=true`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          setBudgetsItems(data.items);
        });
    }
  }, [constructionId]);

  useEffect(() => {
    if (supplierId) {
      api
        .get(`/suppliers/${supplierId}`, { headers: authHeader() })
        .then((res) => {
          const { data } = res.data;
          setRegisteredCategories(data.categories);
        });
    }
  }, [supplierId]);

  function changeNewItems() {
    if (!items.length) {
      setItems([{ category_id: '', item_id: '', total: '' }]);
    }

    if (items.every((item) => item._destroy)) {
      handleAddItems();
    }

    setAddictionalInfo(!addictionalInfo);
  }

  const isDisabled = (currentItem) => {
    const itemNums = budgetsItems.map((item) => item.item_num);
    return itemNums.some((num) => num.startsWith(`${currentItem.item_num}.`));
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
        }}
      >
        <Typography variant="h2">Carregando...</Typography>
        <LinearProgress style={{ width: '80%' }} />
      </div>
    );
  }

  return (
    <>
      <FormBaseScreen
        pageName="Informações do lançamento"
        construction={constructionName}
      >
        {successSubmit && <ToasterBox message={successMessage} />}
        {errorSubmit && <ToasterBox message={errorMessage} />}
        <Snackbar
          open={openSnackBar}
          autoHideDuration={4000}
          onClose={handleCloseSnackBar}
        >
          <Alert
            onClose={handleCloseSnackBar}
            severity="success"
            sx={{ width: '20%' }}
          >
            Copiado!
          </Alert>
        </Snackbar>
        {isAdmin && (
          <SwitchContainerStyled>
            <Typography variant="subtitle2">Pagamento efetuado</Typography>
            <SwitchStyled
              checked={checked}
              onChange={handleChangeStatus}
              inputProps={{ 'aria-label': 'Switch A' }}
            />
          </SwitchContainerStyled>
        )}
        {isAdmin && (
          <TitleAndDeleteContainerStyled>
            <Typography variant="h3">Editar lançamento</Typography>
            {!duplicateMatch && (
              <DeleteDivStyled
                onClick={() => handleOpenDialogDeletePayable()}
                onKeyDown={() => handleOpenDialogDeletePayable()}
                role="button"
                tabIndex={0}
              >
                <MdDelete size={20} color="red" />
                <Typography variant="h5" style={{ color: 'red' }}>
                  Remover lançamento
                </Typography>
              </DeleteDivStyled>
            )}
          </TitleAndDeleteContainerStyled>
        )}
        <BoxesStyled>
          <Box1Styled>
            {isAdmin && (
              <div style={{ display: 'flex', gap: 14 }}>
                <IconStyled>
                  <MdFolder />
                </IconStyled>
                <DropzoneStyled {...getRootProps()}>
                  <input {...getInputProps()} multiple={false} />
                  {isDragActive ? (
                    <Typography>Solte aqui</Typography>
                  ) : (
                    <Typography>Arraste o boleto</Typography>
                  )}
                </DropzoneStyled>
                {ocrLoading && (
                  <LoadingDivStyled>
                    <CircularProgress size={30} />
                  </LoadingDivStyled>
                )}
              </div>
            )}
            <Typography
              variant="h3"
              style={{ margin: '20px 0', fontWeight: 500 }}
            >
              Informações sobre o lançamento
            </Typography>
            <Grid2 container spacing={2}>
              <Grid2 item size={6}>
                <FormControl style={{ m: 2, width: '100%' }}>
                  <Autocomplete
                    disabled={!isAdmin}
                    options={suppliers}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Fornecedor"
                        slotProps={{
                          inputLabel: { shrink: true },
                        }}
                      />
                    )}
                    value={
                      suppliers.find(
                        (supplier) => supplier.id === supplierId
                      ) || null
                    }
                    onChange={(_e, newValue) =>
                      setSupplierId(newValue?.id || '')
                    }
                  />
                </FormControl>
              </Grid2>
              <Grid2 item size={6}>
                <TextField
                  disabled={!isAdmin}
                  label="Código de boleto"
                  variant="outlined"
                  style={{ width: '100%' }}
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  value={bankSlipNumber}
                  onChange={(ev) => setBankSlipNumber(ev.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CopyToClipboard
                          text={bankSlipNumber}
                          onCopy={() => setOpenSnackBar(!openSnackBar)}
                        >
                          <IconButton disabled={!bankSlipNumber} size="large">
                            <MdContentCopy size={19} />
                          </IconButton>
                        </CopyToClipboard>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid2>
              <Grid2 item size={6}>
                <TextField
                  disabled={!isAdmin}
                  fullWidth
                  label="Vencimento"
                  variant="outlined"
                  type="date"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  value={due}
                  onChange={(ev) => {
                    setDue(ev.target.value);
                  }}
                />
              </Grid2>
              <Grid2 item size={6}>
                <TextField
                  disabled={!isAdmin}
                  label="Descrição"
                  style={{ width: '100%' }}
                  variant="outlined"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                />
              </Grid2>
              {!addictionalInfo ? (
                <>
                  <Grid2 item size={6}>
                    <TextField
                      disabled={!isAdmin}
                      fullWidth
                      select
                      variant="outlined"
                      label="Categoria do fornecedor"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      value={category ? category.id : ''}
                      onChange={(e) => handleChangeCategory(e)}
                    >
                      {registeredCategories.length
                        ? registeredCategories.map((categories) => (
                            <MenuItem key={categories.id} value={categories.id}>
                              {categories.name}
                            </MenuItem>
                          ))
                        : category && (
                            <MenuItem value={category.id}>
                              {category.name}
                            </MenuItem>
                          )}
                    </TextField>
                  </Grid2>
                  <Grid2 item size={6}>
                    <TextField
                      fullWidth
                      disabled={!isAdmin}
                      label="Valor"
                      variant="outlined"
                      value={totalDefault}
                      onChange={(e) =>
                        handleChangeTotalInputDefault(currencyMask(e))
                      }
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"> R$ </InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                </>
              ) : null}
              {budgetsItems && constructionId ? (
                isAdmin ? (
                  <AccordionStyled onClick={() => changeNewItems()}>
                    <Typography variant="h4" style={{ color: '#1c1c1c' }}>
                      Associar a itens do orçamento
                    </Typography>
                    <div style={{ paddingRight: 16 }}>
                      {addictionalInfo ? (
                        <MdExpandMore size={24} />
                      ) : (
                        <MdExpandLess size={24} />
                      )}
                    </div>
                  </AccordionStyled>
                ) : (
                  <AccordionStyled>
                    <Typography variant="h4" style={{ color: '#1c1c1c' }}>
                      Itens associados ao orçamento
                    </Typography>
                    <div style={{ paddingRight: 16 }}>
                      {addictionalInfo ? (
                        <MdExpandMore size={24} />
                      ) : (
                        <MdExpandLess size={24} />
                      )}
                    </div>
                  </AccordionStyled>
                )
              ) : (
                <>
                  <AccordionDisableStyled>
                    <Typography variant="h4" style={{ color: '#1c1c1c' }}>
                      {isAdmin
                        ? 'Associar a itens do orçamento'
                        : 'Itens associados ao orçamento'}
                    </Typography>
                    <div style={{ paddingRight: 16 }}>
                      {addictionalInfo ? (
                        <MdExpandMore size={24} />
                      ) : (
                        <MdExpandLess size={24} />
                      )}
                    </div>
                  </AccordionDisableStyled>
                  <p
                    style={{
                      color: '#ff0000',
                      margin: '6px 12px',
                      fontSize: 12,
                      fontFamily: 'montserrat',
                    }}
                  >
                    Para associar items, é preciso cadastrar um orçamento!
                  </p>
                </>
              )}
            </Grid2>
            {addictionalInfo &&
              filteredItems.map((item, index) => (
                <Grid2 container spacing={2} sx={{ margin: '10px 0 25px 0' }}>
                  <Grid2 item sx={{ width: '100%' }}>
                    <TextField
                      disabled={!isAdmin}
                      select
                      fullWidth
                      variant="outlined"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      label="Categoria do fornecedor"
                      value={
                        registeredCategories.length ? item.category_id : ''
                      }
                      onChange={(e) =>
                        handleChangeItems(
                          e,
                          item.destroyBeforeCount + index,
                          'category_id'
                        )
                      }
                    >
                      {registeredCategories.map((categories) => (
                        <MenuItem key={categories.id} value={categories.id}>
                          {categories.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid2>
                  <Grid2 item sx={{ width: '100%' }}>
                    <TextField
                      disabled={!isAdmin}
                      select
                      fullWidth
                      variant="outlined"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      label="Item do orçamento"
                      value={item.item_id || ''}
                      onChange={(e) =>
                        handleChangeItems(
                          e,
                          item.destroyBeforeCount + index,
                          'item_id'
                        )
                      }
                    >
                      {budgetsItems.length ? (
                        budgetsItems.map((bItem) => (
                          <MenuItem
                            key={bItem.id}
                            value={bItem.id}
                            disabled={isDisabled(bItem)}
                          >
                            {`${bItem.item_num} - ${bItem.description}`}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>No Options</MenuItem>
                      )}
                    </TextField>
                  </Grid2>
                  <Grid2 item sx={{ width: '80%' }}>
                    <TextField
                      disabled={!isAdmin}
                      fullWidth
                      label="Valor"
                      variant="outlined"
                      value={item.total}
                      onChange={(e) =>
                        handleChangeAmount(
                          currencyMask(e),
                          item.destroyBeforeCount + index
                        )
                      }
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {' R$ '}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  {isAdmin && (
                    <Grid2 item>
                      <PlusBTNStyled size="small" onClick={handleAddItems}>
                        <MdAdd size={22} />
                      </PlusBTNStyled>
                      <RemoveBTNStyled
                        size="small"
                        onClick={() => handleRemoveItems(item)}
                      >
                        <MdRemove size={22} />
                      </RemoveBTNStyled>
                    </Grid2>
                  )}
                </Grid2>
              ))}
            <LinksAndTotalStyled>
              <div />
              <div>
                <Typography variant="h4">VALOR TOTAL</Typography>
                <Typography color="secondary" variant="h3">
                  {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(total)}
                </Typography>
              </div>
            </LinksAndTotalStyled>
          </Box1Styled>

          <Box2Styled>
            <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
              <Dropzone
                file={attachments}
                setFile={setAttachments}
                route={`/payables/${payableId}/attachments`}
              />
              {loadingAttachment && <CircularProgress size={30} />}
            </div>
            <Typography variant="h4" style={{ padding: '50px 0 20px 0' }}>
              ARQUIVOS
            </Typography>
            {files.map((file) => (
              <AttachmentsListStyled key={file.path}>
                <FileNameStyled>{file.name}</FileNameStyled>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={() => {
                      downloadAttachment(file.id, file.path.content_type);
                    }}
                  >
                    <MdDownload size={22} color="#747474" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setAttachmentId(file.id);
                      setOpenDialogAttachment(!openDialogAttachment);
                    }}
                    style={{ marginRigth: 8 }}
                  >
                    <MdClose size={22} color="#747474" />
                  </IconButton>
                </div>
              </AttachmentsListStyled>
            ))}
          </Box2Styled>
        </BoxesStyled>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div />
          <BtnSubmitStyled onClick={handleSubmitEdit}>Salvar</BtnSubmitStyled>
        </div>
      </FormBaseScreen>
      <DialogBox
        title="Remover lançamento"
        content="Deseja realmente remover esse lançamento? Essa ação não poderá ser desfeita."
        openDialog={openDialog}
        closeDialog={handleCloseDialogDeletePayable}
        mainAction={handleDeletePayable}
      />
      <DialogBox
        title="Apagar arquivo do lançamento"
        content="Deseja realmente apagar este arquivo? Esta ação não poderá ser desfeita"
        openDialog={openDialogAttachment}
        closeDialog={() => setOpenDialogAttachment(!openDialogAttachment)}
        mainAction={() => deleteAttachment(attachmentId)}
      />
    </>
  );
}
